import { defineComponent as o, computed as t } from "vue";
import r from "./index3.js";
import { getConfig as p } from "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
const C = o({
  name: "TrustLogosVuexWrapper",
  components: {
    TrustLogos: r
  },
  props: {
    isSelectionStyle: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    return {
      config: t(
        () => p().values
      )
    };
  }
});
export {
  C as default
};
//# sourceMappingURL=index2.js.map
